import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Frame = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2H2V10L14 10V2ZM2 14V11L14 11V14H2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM12.5 4C12.5 4.27614 12.2761 4.5 12 4.5H4C3.72386 4.5 3.5 4.27614 3.5 4C3.5 3.72386 3.72386 3.5 4 3.5H12C12.2761 3.5 12.5 3.72386 12.5 4ZM12.5 6C12.5 6.27614 12.2761 6.5 12 6.5H4C3.72386 6.5 3.5 6.27614 3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H12C12.2761 5.5 12.5 5.72386 12.5 6ZM8 8.5C8.27614 8.5 8.5 8.27614 8.5 8C8.5 7.72386 8.27614 7.5 8 7.5H4C3.72386 7.5 3.5 7.72386 3.5 8C3.5 8.27614 3.72386 8.5 4 8.5H8ZM12 12.5C12 12.7761 11.7761 13 11.5 13H6.5C6.22386 13 6 12.7761 6 12.5C6 12.2239 6.22386 12 6.5 12H11.5C11.7761 12 12 12.2239 12 12.5ZM4.125 11.875C3.77982 11.875 3.5 12.1548 3.5 12.5C3.5 12.8452 3.77982 13.125 4.125 13.125C4.47018 13.125 4.75 12.8452 4.75 12.5C4.75 12.1548 4.47018 11.875 4.125 11.875Z"
        fill={color}
      />
    </svg>
  )
})

export default Frame
